type SupportedGraphLabelLanguage = 'de-DE' | 'es-ES' | 'fr-FR' | 'ja-JP';

type GraphLabelReplacement = readonly [source: string, replacement: string];

const GRAPH_LABEL_REPLACEMENTS: Record<SupportedGraphLabelLanguage, readonly GraphLabelReplacement[]> = {
    'de-DE': [
        ['Engineer', 'Engineer'],
        ['Manager', 'Manager'],
        ['Director', 'Director'],
        ['Lead', 'Lead'],
        ['Analyst', 'Analyst'],
        ['Architect', 'Architekt'],
        ['Developer', 'Entwickler'],
        ['Designer', 'Designer'],
        ['Specialist', 'Spezialist'],
        ['Officer', 'Officer'],
        ['Consultant', 'Berater'],
        ['Partner', 'Partner'],
        ['Strategy', 'Strategie'],
        ['Management', 'Management'],
        ['Research', 'Research'],
        ['Design', 'Design'],
        ['Marketing', 'Marketing'],
        ['Operations', 'Operations'],
        ['Financial', 'Finanz'],
        ['Talent', 'Talent'],
        ['Learning', 'Learning'],
        ['Software', 'Software'],
        ['Data', 'Daten'],
        ['Product', 'Produkt'],
        ['Security', 'Security'],
        ['Cloud', 'Cloud'],
    ],
    'es-ES': [
        ['Engineer', 'Ingeniero'],
        ['Manager', 'Gerente'],
        ['Director', 'Director'],
        ['Lead', 'Líder'],
        ['Analyst', 'Analista'],
        ['Architect', 'Arquitecto'],
        ['Developer', 'Desarrollador'],
        ['Designer', 'Diseñador'],
        ['Specialist', 'Especialista'],
        ['Officer', 'Responsable'],
        ['Consultant', 'Consultor'],
        ['Partner', 'Partner'],
        ['Strategy', 'Estrategia'],
        ['Management', 'Gestión'],
        ['Research', 'Investigación'],
        ['Design', 'Diseño'],
        ['Marketing', 'Marketing'],
        ['Operations', 'Operaciones'],
        ['Financial', 'Financiero'],
        ['Talent', 'Talento'],
        ['Learning', 'Aprendizaje'],
        ['Software', 'Software'],
        ['Data', 'Datos'],
        ['Product', 'Producto'],
        ['Security', 'Seguridad'],
        ['Cloud', 'Nube'],
    ],
    'fr-FR': [
        ['Engineer', 'Ingénieur'],
        ['Manager', 'Manager'],
        ['Director', 'Directeur'],
        ['Lead', 'Lead'],
        ['Analyst', 'Analyste'],
        ['Architect', 'Architecte'],
        ['Developer', 'Développeur'],
        ['Designer', 'Designer'],
        ['Specialist', 'Spécialiste'],
        ['Officer', 'Responsable'],
        ['Consultant', 'Consultant'],
        ['Partner', 'Partenaire'],
        ['Strategy', 'Stratégie'],
        ['Management', 'Management'],
        ['Research', 'Recherche'],
        ['Design', 'Design'],
        ['Marketing', 'Marketing'],
        ['Operations', 'Opérations'],
        ['Financial', 'Financier'],
        ['Talent', 'Talent'],
        ['Learning', 'Apprentissage'],
        ['Software', 'Logiciel'],
        ['Data', 'Données'],
        ['Product', 'Produit'],
        ['Security', 'Sécurité'],
        ['Cloud', 'Cloud'],
    ],
    'ja-JP': [
        ['Chief', '最高'],
        ['VP of', 'VP'],
        ['Head of', 'ヘッド・オブ'],
        ['Engineer', 'エンジニア'],
        ['Manager', 'マネージャー'],
        ['Director', 'ディレクター'],
        ['Lead', 'リード'],
        ['Analyst', 'アナリスト'],
        ['Architect', 'アーキテクト'],
        ['Developer', '開発者'],
        ['Designer', 'デザイナー'],
        ['Specialist', 'スペシャリスト'],
        ['Officer', 'オフィサー'],
        ['Consultant', 'コンサルタント'],
        ['Partner', 'パートナー'],
        ['Strategy', '戦略'],
        ['Management', '管理'],
        ['Research', 'リサーチ'],
        ['Design', 'デザイン'],
        ['Marketing', 'マーケティング'],
        ['Operations', 'オペレーション'],
        ['Financial', '財務'],
        ['Talent', 'タレント'],
        ['Learning', 'ラーニング'],
        ['Software', 'ソフトウェア'],
        ['Data', 'データ'],
        ['Product', 'プロダクト'],
        ['Security', 'セキュリティ'],
        ['Cloud', 'クラウド'],
        ['Business', 'ビジネス'],
        ['Project', 'プロジェクト'],
        ['Program', 'プログラム'],
        ['People', 'ピープル'],
        ['Compliance', 'コンプライアンス'],
        ['Risk', 'リスク'],
        ['Quality', '品質'],
        ['Supply Chain', 'サプライチェーン'],
        ['Customer Success', 'カスタマーサクセス'],
        ['Technical Writer', 'テクニカルライター'],
    ],
};

const isSupportedGraphLabelLanguage = (languageCode: string): languageCode is SupportedGraphLabelLanguage => {
    return languageCode === 'de-DE' || languageCode === 'es-ES' || languageCode === 'fr-FR' || languageCode === 'ja-JP';
};

export function translateGraphLabel(label: string, languageCode: string): string {
    if (!isSupportedGraphLabelLanguage(languageCode)) return label;

    return GRAPH_LABEL_REPLACEMENTS[languageCode].reduce((translated, [source, replacement]) => {
        return translated.replaceAll(source, replacement);
    }, label);
}
